<template>
  <div class="student-course-dock-panel"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="dockInfo">
      <template v-if="(dockInfo.matches && dockInfo.matches.length) || (dockInfo.performances && dockInfo.performances.length)">
        <AppScrollbar style="height: 100%">
          <div class="dock-main">
            <div v-if="dockInfo.performances && dockInfo.performances.length"
                 class="dock-items">
              <div class="label">
                <TitleGroup title="手动对接"></TitleGroup>
              </div>
              <div class="value">
                <DataGrid size="mini"
                          border="none"
                          resizable
                          highlight-hover-row
                          show-overflow="title"
                          :data="dockInfo.performances">
                  <DataGridColumn title="课程"
                                  min-width="180">
                    <template #default="{row}">
                      <el-tag size="mini"
                              type="primary">{{row.courseType}}</el-tag>
                      <span>{{row.course}}</span>
                    </template>
                  </DataGridColumn>
                  <DataGridColumn title="成绩"
                                  field="score"
                                  width="60"
                                  align="center">
                  </DataGridColumn>
                  <DataGridColumn title="学分"
                                  field="credit"
                                  width="60"
                                  align="center">
                  </DataGridColumn>
                  <DataGridColumn title="对接"
                                  min-width="180">
                    <template #default="{row}">
                      <el-select v-model="row.dockId"
                                 size="mini"
                                 filterable
                                 clearable
                                 placeholder="不做对接"
                                 popper-class="student-course-dock-target-popper">
                        <template v-if="dockInfo.targets">
                          <el-option v-for="target in dockInfo.targets"
                                     :key="target.courseId"
                                     :label="target.course"
                                     :value="target.courseId">
                            <div class="custom-target">
                              <div class="label">
                                <div class="course">{{target.course}}</div>
                                <div class="credit">学分：{{target.credit}}</div>
                              </div>
                              <div class="extra">
                                <el-tag size="mini"
                                        type="primary">{{target.courseType}}</el-tag>
                              </div>
                            </div>
                          </el-option>
                        </template>
                      </el-select>
                    </template>
                  </DataGridColumn>
                </DataGrid>
              </div>
            </div>
            <div v-if="dockInfo.matches && dockInfo.matches.length"
                 class="dock-items">
              <div class="label">
                <TitleGroup title="自动对接"></TitleGroup>
              </div>
              <div class="value">
                <DataGrid size="mini"
                          border="none"
                          resizable
                          highlight-hover-row
                          show-overflow="title"
                          :data="dockInfo.matches">
                  <DataGridColumn title="课程"
                                  min-width="180">
                    <template #default="{row}">
                      <el-tag size="mini"
                              type="primary">{{row.courseType}}</el-tag>
                      <span>{{row.course}}</span>
                    </template>
                  </DataGridColumn>
                  <DataGridColumn title="成绩"
                                  field="score"
                                  width="60"
                                  align="center">
                  </DataGridColumn>
                  <DataGridColumn title="学分"
                                  field="credit"
                                  width="60"
                                  align="center">
                  </DataGridColumn>
                  <DataGridColumn title="对接"
                                  min-width="180">
                    <template #default="{row}">
                      <template v-if="row.dock">
                        <el-tag size="mini"
                                type="primary">{{row.dock.courseType}}</el-tag>
                        <span>{{row.dock.course}}</span>
                      </template>
                    </template>
                  </DataGridColumn>
                </DataGrid>
              </div>
            </div>
          </div>
        </AppScrollbar>
      </template>
      <template v-else>
        <Hint :icon="false">
          <div>没有可对接信息</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>对接数据加载失败</div>
        <el-button type="text"
                   @click="loadDockInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../../widgets/custom/TitleGroup'
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'StudentCourseDockPanel',
  components: {
    AppScrollbar,
    TitleGroup,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    clazzId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      dockInfo: null
    }
  },
  computed: {
    dockParams () {
      return {
        studentId: this.studentId,
        clazzId: this.clazzId
      }
    }
  },
  methods: {
    loadDockInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/student/info/dock',
        method: 'post',
        data: this.$qs.stringify(this.dockParams)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.dockInfo = response.data['dockInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    getDockInfo () {
      return new Promise((resolve, reject) => {
        let dockInfo = this.dockInfo
        if (dockInfo) {
          let performances = (dockInfo.performances || [])
            .filter(item => !!item.dockId)
          let isValid = performances.every((item, index) => {
            for (let i = 0; i < index; i++) {
              if (performances[i].dockId === item.dockId) {
                reject(new Error('不能将多门课对接到同一门课'))
                return
              }
            }
            return true
          })
          if (!isValid) {
            return
          }
          resolve({
            dockApply: JSON.stringify({
              mappings: performances.map(item => {
                return {
                  id: item.id,
                  dockId: item.dockId
                }
              })
            })
          })
        } else {
          reject(new Error('对接数据未加载'))
        }
      })
    }
  },
  mounted () {
    this.loadDockInfo()
  },
  watch: {
    dockParams: {
      handler () {
        this.dockInfo = null
        this.$nextTick(() => {
          this.loadDockInfo()
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .student-course-dock-panel {
    min-height: 120px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    .dock-main {
      max-height: 420px;
      padding: 5px 0;
      & > .dock-items {
        & > .label {
          .title-group {
            & > .main {
              margin-top: 2px;
            }
          }
        }
        & > .value {
          .vxe-table {
            .vxe-table--header-wrapper {
              .vxe-table--header {
                .vxe-header--row {
                  background-color: #f3f4f5;
                }
              }
            }
            .vxe-table--body-wrapper {
              .vxe-table--body {
                .vxe-body--row {
                  .vxe-body--column {

                  }
                }
              }
            }
          }
        }
        & + .dock-items {
          margin-top: 10px;
        }
      }
    }
    .layout-hint {
      height: 120px;
    }
  }
  .el-select-dropdown {
    &.student-course-dock-target-popper {
      .el-select-dropdown__wrap {
        .el-select-dropdown__list {
          .el-select-dropdown__item {
            height: 46px;
            line-height: 46px;
            .custom-target {
              display: flex;
              justify-content: space-between;
              align-items: center;
              & > .label {
                & > .course {
                  line-height: 26px;
                }
                & > .credit {
                  margin-top: -4px;
                  color: #909399;
                  font-size: 12px;
                  line-height: 20px;
                }
              }
              & > .extra {
                margin-left: 15px;
              }
            }
          }
        }
      }
    }
  }
</style>
